import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component RecurringIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <RecurringIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <RecurringIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RecurringIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="RecurringIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.364 2.636l.225.233.214.238a8.862 8.862 0 012.04 4.216l.043.25c.071.44.109.886.114 1.332h-.007l.001.095h-2.008a6.95 6.95 0 00-1.43-4.26l-.095-.12a7 7 0 00-10.238-.738l-.173.168 1.414 1.414-4.872.63.63-4.872 1.414 1.414A8.976 8.976 0 019.361.007c2.1.084 4.175.898 5.813 2.444l.19.185zM2.636 15.364a8.892 8.892 0 01-2.498-4.789A9.016 9.016 0 010 9.01h.006V9h2.008a6.944 6.944 0 001.826 4.73l.21.22a7 7 0 009.727.167l.173-.167-1.414-1.414 4.871-.63-.629 4.872-1.414-1.414a9 9 0 01-12.728 0z"
      />
    </svg>
  )
);
RecurringIcon.displayName = "RecurringIcon";
export default RecurringIcon;
